import type { TOC } from '@ember/component/template-only';
import type { EmberChangeset } from 'ember-changeset';
import t from 'ember-intl/helpers/t';
import type { WrFormComponentSignature } from 'ember-wiser/components/form';

interface Signature {
  Args: {
    form: WrFormComponentSignature<
      EmberChangeset,
      void
    >['Blocks']['default'][0];
  };
}
export default <template>
  <@form.InputRow
    @name='feverLevel'
    @label={{t 'mici-form.feverLevel.long' htmlSafe=true}}
    type='number'
  />
</template> satisfies TOC<Signature>;
